var $ = (global.jQuery = require('jquery'));
var _ = require('underscore');
var Marionette = require('backbone.marionette');
require('select2');

var OrderedSelect2 = Marionette.ItemView.extend({
    events: {
        'change @ui.select': 'removeUnselected',
    },
    template: false,
    ui: {
        select: 'select:first',
    },
    initialize: function(options) {
        var select2Options = options.select2Options || {};

        _.extend(select2Options, {
            ajax: {
                transport: _.bind(function(params, success, failure) {
                    var $request = $.Deferred();
                    $request.then(success);
                    $request.fail(failure);
                    $request.resolve(this.filterData({ term: params.data.q }));
                    return $request;
                }, this),
                processResults: function(data) {
                    return { results: data };
                },
            },
        });

        this.options.select2Options = select2Options;

        this.on('deserialize', this.setInitialValues);
    },
    setInitialValues: function(initialValues) {
        var data = this.getData();
        var html = _.reduce(
            initialValues,
            function(memo, value) {
                var dataValue = _.findWhere(data, { id: value });
                if (dataValue) {
                    return memo + '<option value="' + dataValue.id + '">' + dataValue.text + '</option>\n';
                }
                return memo;
            },
            ''
        );

        this.selectEl
            .append(html)
            .val(initialValues)
            .change();
    },
    filterData: function(params) {
        var matcher = $.fn.select2.amd.require('select2/defaults').defaults.matcher;

        return _.filter(this.getData(), function(agent) {
            return matcher(params, agent);
        });
    },
    getData: function() {
        return _.isFunction(this.options.data) ? this.options.data.call(this) : this.options.data;
    },
    onRender: function() {
        this.selectEl = this.getOption('selectEl') || this.$('select:first, input:first');
        var dropdownParent = $('<div>').addClass('select2-dropdown-container');
        this.ui.select.parent().append(dropdownParent);
        this.ui.select.select2(_.extend({ width: '100%' }, this.getOption('select2Options')));
    },
    removeUnselected: function() {
        this.ui.select.find('option:not(:selected)').remove();
    },
    onBeforeDestroy: function() {
        if (this.ui.select.data('select2')) {
            this.ui.select.select2('destroy');
        }
    },
});

module.exports = OrderedSelect2;
